// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing_pitch {
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* height: 25rem; */
    margin: 2rem;

}
.pitchVdoCard_main{
    height: 18rem;
    position: relative
}
#pitchVdoCard {
    border-radius: 20px;
    /* background-color: blanchedalmond; */
    height: 12rem;
    width: 21rem;
    position: absolute;
    padding: 0;
    box-shadow: rgb(117, 119, 120) 0px 20px 10px -10px;


    /* border: 1.5px dotted white; */
}

.pitchVdoCard_overlay {
    background: blue;
    height: 2rem;
    width: 2rem;
    position: absolute;
    border-radius: 12px;
}

.pitch_vide_card_name {
    position: absolute;
    cursor: pointer;
    color: #000000;
    left: 0%;
    top: 100%;
    transition: 800ms;
    padding: 5px;
    background-color: #ffffff;
    border-radius: 5px;



}

.pitch_vide_card_name:hover {
    transition: 800ms;
    background-color: #ffffff;
    color: black;
    scale: 1.05;
    padding: 5px 10px;


}

.vdo_div{
    width: 320px;
    height: 200px;
    /* margin: 0 5rem;
    padding-top: 0;
    padding-bottom: 0; */
}
.ptch_vdo_player{
    width: 100%;
    height: 100%;
    
}

@media only screen and (max-width: 600px) {
    #pitchVdoCard {
        height: 10rem;
        width: 16rem;
    }
    .pitchVdoCard_overlay{
        height: 10rem;
        width: 16rem;
      
    }
    .pitchVdoCard_main{
        height: 14rem;
    }
    .vdo_div{
        margin: 0;
        padding: 0;
        width: 280px;
        height: 200px;
    }
    .landing_pitch{
        padding: 0;
        margin: 0;
    }
}

@media only screen and (max-width: 600px) and (min-width: 400px){

    #pitchVdoCard {
        height: 10rem;
        width: 12rem;
    }
    .pitchVdoCard_overlay{
        height: 10rem;
        width: 12rem;
      
    }
    .pitchVdoCard_main{
        height: 14rem;
    }

}`, "",{"version":3,"sources":["webpack://./src/Component new/PitchCrousel/PitchCraousel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;;AAEhB;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,kDAAkD;;;IAGlD,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;;;;AAItB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,iBAAiB;;;AAGrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb;;wBAEoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI;QACI,aAAa;QACb,YAAY;IAChB;IACA;QACI,aAAa;QACb,YAAY;;IAEhB;IACA;QACI,aAAa;IACjB;IACA;QACI,SAAS;QACT,UAAU;QACV,YAAY;QACZ,aAAa;IACjB;IACA;QACI,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;;IAEI;QACI,aAAa;QACb,YAAY;IAChB;IACA;QACI,aAAa;QACb,YAAY;;IAEhB;IACA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".landing_pitch {\r\n    padding: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* height: 25rem; */\r\n    margin: 2rem;\r\n\r\n}\r\n.pitchVdoCard_main{\r\n    height: 18rem;\r\n    position: relative\r\n}\r\n#pitchVdoCard {\r\n    border-radius: 20px;\r\n    /* background-color: blanchedalmond; */\r\n    height: 12rem;\r\n    width: 21rem;\r\n    position: absolute;\r\n    padding: 0;\r\n    box-shadow: rgb(117, 119, 120) 0px 20px 10px -10px;\r\n\r\n\r\n    /* border: 1.5px dotted white; */\r\n}\r\n\r\n.pitchVdoCard_overlay {\r\n    background: blue;\r\n    height: 2rem;\r\n    width: 2rem;\r\n    position: absolute;\r\n    border-radius: 12px;\r\n}\r\n\r\n.pitch_vide_card_name {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    left: 0%;\r\n    top: 100%;\r\n    transition: 800ms;\r\n    padding: 5px;\r\n    background-color: #ffffff;\r\n    border-radius: 5px;\r\n\r\n\r\n\r\n}\r\n\r\n.pitch_vide_card_name:hover {\r\n    transition: 800ms;\r\n    background-color: #ffffff;\r\n    color: black;\r\n    scale: 1.05;\r\n    padding: 5px 10px;\r\n\r\n\r\n}\r\n\r\n.vdo_div{\r\n    width: 320px;\r\n    height: 200px;\r\n    /* margin: 0 5rem;\r\n    padding-top: 0;\r\n    padding-bottom: 0; */\r\n}\r\n.ptch_vdo_player{\r\n    width: 100%;\r\n    height: 100%;\r\n    \r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n    #pitchVdoCard {\r\n        height: 10rem;\r\n        width: 16rem;\r\n    }\r\n    .pitchVdoCard_overlay{\r\n        height: 10rem;\r\n        width: 16rem;\r\n      \r\n    }\r\n    .pitchVdoCard_main{\r\n        height: 14rem;\r\n    }\r\n    .vdo_div{\r\n        margin: 0;\r\n        padding: 0;\r\n        width: 280px;\r\n        height: 200px;\r\n    }\r\n    .landing_pitch{\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 600px) and (min-width: 400px){\r\n\r\n    #pitchVdoCard {\r\n        height: 10rem;\r\n        width: 12rem;\r\n    }\r\n    .pitchVdoCard_overlay{\r\n        height: 10rem;\r\n        width: 12rem;\r\n      \r\n    }\r\n    .pitchVdoCard_main{\r\n        height: 14rem;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
